module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Teachers")]), _vm._v(" "), _c('ul', _vm._l((_vm.users), function(user) {
    return _c('li', {
      staticClass: "pl-subheading"
    }, [_c('strong', [_vm._v("Name")]), _vm._v(": " + _vm._s(user.name) + "\n      "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Email")]), _vm._v(": " + _vm._s(user.email) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7a37f25d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/individualSchoolTabs/manageTeachersInSchool.vue
// module id = 1984
// module chunks = 61